const TZ = "Asia/Manila";

const toDate = (v) => (v ? new Date(v) : null);

export const fmtDateTime = (v) => {
  const d = toDate(v);
  return d ? d.toLocaleString("en-PH", { timeZone: TZ, dateStyle: "medium", timeStyle: "short" }) : "—";
};

export const fmtDate = (v) => {
  if (!v) return "—";
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split("-").map(Number);
    return new Date(y, m - 1, d).toLocaleDateString("en-PH", { dateStyle: "medium" });
  }
  return toDate(v).toLocaleDateString("en-PH", { timeZone: TZ, dateStyle: "medium" });
};

export const fmtBytes = (n) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

export const label = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
